export default class Modale {
  constructor(element) {
    this.element = element;
    this.opens = document.querySelectorAll('.js-modale-open');
    this.closes = this.element.querySelectorAll('.js-modale-close');
    this.html = document.documentElement;

    this.init();
  }

  init() {
    this.setOptions();

    for (let i = 0; i < this.opens.length; i++) {
      const open = this.opens[i];
      console.log(open);
      open.addEventListener('click', this.openModale.bind(this));
    }
    for (let i = 0; i < this.closes.length; i++) {
      const close = this.closes[i];
      close.addEventListener('click', this.closeModale.bind(this));
    }
  }

  setOptions() {}

  openModale() {
    console.log('OpenModale');
    this.html.classList.add('modale-is-open');
  }
  closeModale() {
    console.log('CloseModale');
    this.html.classList.remove('modale-is-open');
  }
}
